// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"_7SHmlUFjUY_1Q10zmdAxl"};